/* eslint-disable @typescript-eslint/no-explicit-any */
interface TimeSlot {
  display: string;
  startTime: string;
  endTime: string;
  daysOfWeek: number[];
  classNames: string[];
}

export function getUnavailableHours(availability: any): any {
  const unavailableHours: TimeSlot[] = [];

  for (let day = 0; day <= 6; day += 1) {
    const dayAvailability = availability.filter((slot: any) =>
      slot.daysOfWeek.includes(day),
    );
    const dayUnavailableHours: TimeSlot[] = [];

    if (dayAvailability.length === 0) {
      // If no available hours, mark the whole day as unavailable
      dayUnavailableHours.push({
        display: 'background',
        startTime: '00:00',
        endTime: '23:59',
        daysOfWeek: [day],
        classNames: ['unavailable'],
      });
    } else {
      dayAvailability.sort((a: any, b: any) => {
        const timeA = new Date(`1970-01-01T${a.startTime}`);
        const timeB = new Date(`1970-01-01T${b.startTime}`);
        return timeA.getTime() - timeB.getTime();
      });

      let startTime = new Date(`1970-01-01T00:00`);

      dayAvailability.forEach((slot: any) => {
        const endTime = new Date(`1970-01-01T${slot.startTime}`);

        if (endTime > startTime) {
          dayUnavailableHours.push({
            display: 'background',
            startTime: startTime.toTimeString().slice(0, 5),
            endTime: endTime.toTimeString().slice(0, 5),
            daysOfWeek: [day],
            classNames: ['unavailable'],
          });
        }

        startTime = new Date(`1970-01-01T${slot.endTime}`);
      });
      const endTime = new Date(`1970-01-01T23:59`);
      if (endTime > startTime) {
        dayUnavailableHours.push({
          display: 'background',
          startTime: startTime.toTimeString().slice(0, 5),
          endTime: endTime.toTimeString().slice(0, 5),
          daysOfWeek: [day],
          classNames: ['unavailable'],
        });
      }
    }

    unavailableHours.push(...dayUnavailableHours);
  }

  return unavailableHours;
}
